import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import warningImg from '../../assets/warning.png'
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'
import './ValidateModal.css'
function ValidateModal({ handleClick, validatepopupshow }) {

    const navigate = useNavigate();
    return (
        <>
            <Modal show={validatepopupshow}            
                backdrop="static"
                keyboard={false}
                onHide={() => { handleClick() }}>
                <Modal.Header closeButton>
                    <Modal.Title>Profile Update</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{paddingBottom:"2pc",}}>
                    <div className='d-flex align-items-center justify-content-around'> 
                    <FontAwesomeIcon icon={faTriangleExclamation} beat style={{color: "#bc6969",width: '60px', height: '60px',borderWidth:"4px"}}  />
                        {/* <img src={warningImg} alt="warning" /> */}
                        <div>
                            {/* <h1 style={{ color: '#EB1E25' }}>Warning</h1> */}
                            <h6 style={{paddingBottom:"2rem"}}>You Must Update Your Profile</h6>
                            <div className="m-2" >
                                <button type="submit" onClick={() => { navigate('/Edit_profile') }} id='volsavebtn' className="btn btn-primary" style={{ backgroundColor: "#790909", borderColor: "#2fba19", color: "white" }} >Proceed</button>

                            </div>
                        </div>

                    </div>


                </Modal.Body>
            </Modal>

        </>
    )
}

export default ValidateModal